import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_add_icon = _resolveComponent("v-btn-add-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    eager: "",
    location: "left"
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn_add_icon, _mergeProps({
        variant: "plain",
        color: "secondary",
        density: "comfortable",
        class: "pl-1"
      }, props), null, 16)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "pa-0",
        elevation: "2",
        rounded: "md"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, { class: "pa-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_toggle, {
                        class: "d-flex fill-width",
                        style: {"background-color":"white"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            rounded: "",
                            outlined: "",
                            class: "flex-grow-1",
                            elevation: "0",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.OnMailOptionSelected('$TITLE'))),
                            size: "small"
                          }, {
                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                              _createTextVNode(" Titre ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_btn, {
                            rounded: "",
                            outlined: "",
                            class: "flex-grow-1",
                            elevation: "0",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.OnMailOptionSelected('$NUMBER'))),
                            size: "small"
                          }, {
                            default: _withCtx(() => _cache[12] || (_cache[12] = [
                              _createTextVNode(" Numéro de facture ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_btn, {
                            rounded: "",
                            outlined: "",
                            class: "flex-grow-1",
                            elevation: "0",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.OnMailOptionSelected('$PRICE'))),
                            size: "small"
                          }, {
                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                              _createTextVNode(" Prix ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_btn, {
                            rounded: "",
                            outlined: "",
                            class: "flex-grow-1",
                            elevation: "0",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.OnMailOptionSelected('$IBAN'))),
                            size: "small"
                          }, {
                            default: _withCtx(() => _cache[14] || (_cache[14] = [
                              _createTextVNode(" IBAN ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_toggle, {
                        class: "d-flex fill-width",
                        style: {"background-color":"white"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            rounded: "",
                            outlined: "",
                            class: "flex-grow-1",
                            elevation: "0",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.OnMailOptionSelected('$USER_NAME'))),
                            size: "small"
                          }, {
                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                              _createTextVNode(" Utilisateur ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_btn, {
                            rounded: "",
                            outlined: "",
                            class: "flex-grow-1",
                            elevation: "0",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.OnMailOptionSelected('$COMPANY_NAME'))),
                            size: "small"
                          }, {
                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                              _createTextVNode(" Société emettrice ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_btn, {
                            rounded: "",
                            outlined: "",
                            class: "flex-grow-1",
                            elevation: "0",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.OnMailOptionSelected('$CLIENT_COMPANY_NAME'))),
                            size: "small"
                          }, {
                            default: _withCtx(() => _cache[17] || (_cache[17] = [
                              _createTextVNode(" Société destinataire ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_btn, {
                            rounded: "",
                            outlined: "",
                            class: "flex-grow-1",
                            elevation: "0",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.OnMailOptionSelected('$RECEIVER_NAME'))),
                            size: "small"
                          }, {
                            default: _withCtx(() => _cache[18] || (_cache[18] = [
                              _createTextVNode(" Contact client ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_toggle, {
                        class: "d-flex fill-width",
                        style: {"background-color":"white"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            rounded: "",
                            outlined: "",
                            class: "flex-grow-1",
                            elevation: "0",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.OnMailOptionSelected('$INVOICE_DATE'))),
                            size: "small"
                          }, {
                            default: _withCtx(() => _cache[19] || (_cache[19] = [
                              _createTextVNode(" Date ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_btn, {
                            rounded: "",
                            outlined: "",
                            class: "flex-grow-1",
                            elevation: "0",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.OnMailOptionSelected('$INVOICE_DUE_DATE'))),
                            size: "small"
                          }, {
                            default: _withCtx(() => _cache[20] || (_cache[20] = [
                              _createTextVNode(" Date d'échéance ")
                            ])),
                            _: 1
                          }),
                          (_ctx.isInvoiceNextDueDate)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                rounded: "",
                                outlined: "",
                                class: "flex-grow-1",
                                elevation: "0",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.OnMailOptionSelected('$INVOICE_NEXT_DUE_DATE'))),
                                size: "small"
                              }, {
                                default: _withCtx(() => _cache[21] || (_cache[21] = [
                                  _createTextVNode(" Délai + 30 jours ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}